// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BasicInformation_GrantorFragment = { __typename?: 'Principal', id: string, ownershipPercentage?: Percent | null, individual?: { __typename?: 'ClientProfile', id: string, legalName: string } | null };

export type BasicInformation_ControllingPartyFragment = { __typename?: 'ControllingParty', id: string, individual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, organization?: { __typename?: 'ClientOrganization', id: string, name: string } | null };

export type BasicInformation_OwnerFragment = { __typename?: 'Principal', id: string, ownershipPercentage?: Percent | null, individual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null };

export type BasicInformation_IrrevocableTrustFragment = { __typename?: 'IrrevocableTrust', id: string, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, tenantID: string, trustJurisdictionStateCode?: string | null, successorTrustees?: Array<{ __typename?: 'Trustee', id: string }> | null, trustAdvisors?: Array<{ __typename?: 'TrustAdvisor', id: string }> | null, trustees?: Array<{ __typename?: 'Trustee', id: string }> | null, grantors?: Array<(
    { __typename?: 'Principal' }
    & BasicInformation_GrantorFragment
  )> | null };

export type BasicInformation_RevocableTrustFragment = { __typename?: 'RevocableTrust', id: string, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, tenantID: string, trustJurisdictionStateCode?: string | null, successorTrustees?: Array<{ __typename?: 'Trustee', id: string }> | null, trustAdvisors?: Array<{ __typename?: 'TrustAdvisor', id: string }> | null, trustees?: Array<{ __typename?: 'Trustee', id: string }> | null, grantors?: Array<(
    { __typename?: 'Principal' }
    & BasicInformation_GrantorFragment
  )> | null };

export type BasicInformation_SlatTrustFragment = { __typename?: 'SLATTrust', id: string, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, tenantID: string, trustJurisdictionStateCode?: string | null, successorTrustees?: Array<{ __typename?: 'Trustee', id: string }> | null, trustAdvisors?: Array<{ __typename?: 'TrustAdvisor', id: string }> | null, trustees?: Array<{ __typename?: 'Trustee', id: string }> | null, slatGrantor?: (
    { __typename?: 'Principal' }
    & BasicInformation_GrantorFragment
  ) | null };

export type BasicInformation_IlitTrustFragment = { __typename?: 'ILITTrust', id: string, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, tenantID: string, trustJurisdictionStateCode?: string | null, successorTrustees?: Array<{ __typename?: 'Trustee', id: string }> | null, trustAdvisors?: Array<{ __typename?: 'TrustAdvisor', id: string }> | null, trustees?: Array<{ __typename?: 'Trustee', id: string }> | null, grantors?: Array<(
    { __typename?: 'Principal' }
    & BasicInformation_GrantorFragment
  )> | null };

export type BasicInformation_GratTrustFragment = { __typename?: 'GRATTrust', id: string, description?: string | null, entityExists: boolean, displayName: string, taxableGift?: CurrencyUSD | null, officialInterestRatePercent?: Percent | null, effectiveDate?: Time | null, legalName?: string | null, initialFundingValue?: CurrencyUSD | null, tenantID: string, termDurationYears?: number | null, trustJurisdictionStateCode?: string | null, successorTrustees?: Array<{ __typename?: 'Trustee', id: string }> | null, trustAdvisors?: Array<{ __typename?: 'TrustAdvisor', id: string }> | null, trustees?: Array<{ __typename?: 'Trustee', id: string }> | null, gratGrantor?: (
    { __typename?: 'Principal' }
    & BasicInformation_GrantorFragment
  ) | null };

export type BasicInformation_QprtTrustFragment = { __typename?: 'QPRTTrust', id: string, termDurationYears?: number | null, officialInterestRatePercent?: Percent | null, taxableGift?: CurrencyUSD | null, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, tenantID: string, trustJurisdictionStateCode?: string | null, successorTrustees?: Array<{ __typename?: 'Trustee', id: string }> | null, trustAdvisors?: Array<{ __typename?: 'TrustAdvisor', id: string }> | null, trustees?: Array<{ __typename?: 'Trustee', id: string }> | null, grantors?: Array<(
    { __typename?: 'Principal' }
    & BasicInformation_GrantorFragment
  )> | null };

export type BasicInformation_IndividualPersonalAccountFragment = { __typename?: 'IndividualPersonalAccount', id: string, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, tenantID: string, owner?: (
    { __typename?: 'Principal' }
    & BasicInformation_OwnerFragment
  ) | null, controllingParties?: Array<(
    { __typename?: 'ControllingParty' }
    & BasicInformation_ControllingPartyFragment
  )> | null };

export type BasicInformation_JointPersonalAccountFragment = { __typename?: 'JointPersonalAccount', id: string, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, tenantID: string, jointAccountType?: Types.JointPersonalAccountType | null, owners?: Array<(
    { __typename?: 'Principal' }
    & BasicInformation_OwnerFragment
  )> | null, controllingParties?: Array<(
    { __typename?: 'ControllingParty' }
    & BasicInformation_ControllingPartyFragment
  )> | null };

export type BasicInformation_InsurancePersonalAccountFragment = { __typename?: 'InsurancePersonalAccount', id: string, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, tenantID: string, owners?: Array<(
    { __typename?: 'Principal' }
    & BasicInformation_OwnerFragment
  )> | null, controllingParties?: Array<(
    { __typename?: 'ControllingParty' }
    & BasicInformation_ControllingPartyFragment
  )> | null };

export type BasicInformation_CltTrustFragment = { __typename?: 'CLTTrust', id: string, termDurationYears?: number | null, officialInterestRatePercent?: Percent | null, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, charitableDeduction?: CurrencyUSD | null, termDurationLifetime: boolean, tenantID: string, trustJurisdictionStateCode?: string | null, successorTrustees?: Array<{ __typename?: 'Trustee', id: string }> | null, trustAdvisors?: Array<{ __typename?: 'TrustAdvisor', id: string }> | null, trustees?: Array<{ __typename?: 'Trustee', id: string }> | null, grantors?: Array<(
    { __typename?: 'Principal' }
    & BasicInformation_GrantorFragment
  )> | null };

export type BasicInformation_CrtTrustFragment = { __typename?: 'CRTTrust', id: string, termDurationYears?: number | null, officialInterestRatePercent?: Percent | null, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, charitableDeduction?: CurrencyUSD | null, termDurationLifetime: boolean, tenantID: string, trustJurisdictionStateCode?: string | null, successorTrustees?: Array<{ __typename?: 'Trustee', id: string }> | null, trustAdvisors?: Array<{ __typename?: 'TrustAdvisor', id: string }> | null, trustees?: Array<{ __typename?: 'Trustee', id: string }> | null, grantors?: Array<(
    { __typename?: 'Principal' }
    & BasicInformation_GrantorFragment
  )> | null };

export type BasicInformation_RetirementPersonalAccountFragment = { __typename?: 'RetirementPersonalAccount', id: string, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, tenantID: string, custodian?: string | null, retirementAccountType?: Types.RetirementPersonalAccountType | null, owner?: (
    { __typename?: 'Principal' }
    & BasicInformation_OwnerFragment
  ) | null, controllingParties?: Array<(
    { __typename?: 'ControllingParty' }
    & BasicInformation_ControllingPartyFragment
  )> | null };

export type BasicInformation_CustodialPersonalAccountFragment = { __typename?: 'CustodialPersonalAccount', id: string, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, tenantID: string, owner?: (
    { __typename?: 'Principal' }
    & BasicInformation_OwnerFragment
  ) | null, controllingParties?: Array<(
    { __typename?: 'ControllingParty' }
    & BasicInformation_ControllingPartyFragment
  )> | null };

export type BasicInformation_QualifiedTuitionPersonalAccountFragment = { __typename?: 'QualifiedTuitionPersonalAccount', id: string, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, tenantID: string, owner?: (
    { __typename?: 'Principal' }
    & BasicInformation_OwnerFragment
  ) | null, controllingParties?: Array<(
    { __typename?: 'ControllingParty' }
    & BasicInformation_ControllingPartyFragment
  )> | null };

export type BasicInformation_DafFragment = { __typename?: 'DonorAdvisedFund', id: string, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, tenantID: string, donors?: Array<(
    { __typename?: 'Principal' }
    & BasicInformation_OwnerFragment
  )> | null, controllingParties?: Array<(
    { __typename?: 'ControllingParty' }
    & BasicInformation_ControllingPartyFragment
  )> | null };

export type BasicInformation_PrivateFoundationFragment = { __typename?: 'PrivateFoundation', id: string, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, tenantID: string, donors?: Array<(
    { __typename?: 'Principal' }
    & BasicInformation_OwnerFragment
  )> | null, controllingParties?: Array<(
    { __typename?: 'ControllingParty' }
    & BasicInformation_ControllingPartyFragment
  )> | null };

export type BasicInformation_BusinessEntity_CCorpBusinessEntity_Fragment = { __typename?: 'CCorpBusinessEntity', id: string, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, doingBusinessAsName?: string | null, formationJurisdictionStateCode?: string | null, requiresCtaReporting?: boolean | null, finCenID?: string | null };

export type BasicInformation_BusinessEntity_GpBusinessEntity_Fragment = { __typename?: 'GPBusinessEntity', id: string, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, doingBusinessAsName?: string | null, formationJurisdictionStateCode?: string | null, requiresCtaReporting?: boolean | null, finCenID?: string | null };

export type BasicInformation_BusinessEntity_LlcBusinessEntity_Fragment = { __typename?: 'LLCBusinessEntity', id: string, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, doingBusinessAsName?: string | null, formationJurisdictionStateCode?: string | null, requiresCtaReporting?: boolean | null, finCenID?: string | null };

export type BasicInformation_BusinessEntity_LpBusinessEntity_Fragment = { __typename?: 'LPBusinessEntity', id: string, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, doingBusinessAsName?: string | null, formationJurisdictionStateCode?: string | null, requiresCtaReporting?: boolean | null, finCenID?: string | null };

export type BasicInformation_BusinessEntity_SCorpBusinessEntity_Fragment = { __typename?: 'SCorpBusinessEntity', id: string, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, doingBusinessAsName?: string | null, formationJurisdictionStateCode?: string | null, requiresCtaReporting?: boolean | null, finCenID?: string | null };

export type BasicInformation_BusinessEntity_SoleProprietorshipBusinessEntity_Fragment = { __typename?: 'SoleProprietorshipBusinessEntity', id: string, description?: string | null, entityExists: boolean, displayName: string, effectiveDate?: Time | null, legalName?: string | null, doingBusinessAsName?: string | null, formationJurisdictionStateCode?: string | null, requiresCtaReporting?: boolean | null, finCenID?: string | null };

export type BasicInformation_BusinessEntityFragment = BasicInformation_BusinessEntity_CCorpBusinessEntity_Fragment | BasicInformation_BusinessEntity_GpBusinessEntity_Fragment | BasicInformation_BusinessEntity_LlcBusinessEntity_Fragment | BasicInformation_BusinessEntity_LpBusinessEntity_Fragment | BasicInformation_BusinessEntity_SCorpBusinessEntity_Fragment | BasicInformation_BusinessEntity_SoleProprietorshipBusinessEntity_Fragment;

export type GetBasicInformationQueryVariables = Types.Exact<{
  nodeId: Types.Scalars['ID']['input'];
}>;


export type GetBasicInformationQuery = { __typename?: 'Query', node?: { __typename?: 'AISuggestion' } | { __typename?: 'AISuggestionEvidence' } | { __typename?: 'AccessAgeParameter' } | { __typename?: 'AccessParameter' } | { __typename?: 'Account' } | { __typename?: 'ActiveEstateInsightsPage' } | { __typename?: 'Activity' } | { __typename?: 'Address' } | { __typename?: 'Answer' } | { __typename?: 'AnswerEvidence' } | { __typename?: 'AnswerRevision' } | { __typename?: 'Approval' } | { __typename?: 'AssetClass' } | { __typename?: 'AssetGroup' } | { __typename?: 'AssetStatic' } | { __typename?: 'AssetV2' } | { __typename?: 'AssetValuationV2' } | { __typename?: 'AssetValueV2' } | { __typename?: 'AsyncJob' } | { __typename?: 'BalanceSheetBundleConfiguration' } | { __typename?: 'BalanceSheetCategory' } | { __typename?: 'BalanceSheetViewConfiguration' } | { __typename?: 'BeneficiariesBundleConfiguration' } | { __typename?: 'BeneficiariesTemplateBundleConfiguration' } | { __typename?: 'Beneficiary' } | { __typename?: 'BeneficiaryAccessParameter' } | { __typename?: 'BeneficiaryDesignationGroup' } | { __typename?: 'BeneficiaryDistribution' } | { __typename?: 'BeneficiaryDistributionParameter' } | { __typename?: 'BeneficiaryPage' } | { __typename?: 'BeneficiaryPowerOfAppointment' } | { __typename?: 'CCorpBusinessEntity' } | { __typename?: 'CLTProposal' } | { __typename?: 'CLTTrust' } | { __typename?: 'CRTProposal' } | { __typename?: 'CRTTrust' } | { __typename?: 'Capability' } | { __typename?: 'Cashflow' } | { __typename?: 'ClientOrganization' } | { __typename?: 'ClientPresentationV2' } | { __typename?: 'ClientProfile' } | { __typename?: 'ClientProfileRelationship' } | { __typename?: 'Collaborator' } | { __typename?: 'ComparedWaterfall' } | { __typename?: 'CompletedEstateInsightsPage' } | { __typename?: 'ControllingParty' } | { __typename?: 'Conversation' } | { __typename?: 'CoverPageConfiguration' } | { __typename?: 'CustodialPersonalAccount' } | { __typename?: 'DSUEPortability' } | { __typename?: 'DiagramArtifact' } | { __typename?: 'DiagramArtifactPrompt' } | { __typename?: 'DispositionScenario' } | { __typename?: 'DispositiveProvision' } | { __typename?: 'DispositiveProvisionTemplate' } | { __typename?: 'DividerBundleConfiguration' } | { __typename?: 'DividerTemplateBundleConfiguration' } | { __typename?: 'Document' } | { __typename?: 'DocumentQuestion' } | { __typename?: 'DocumentQuestionAnswers' } | { __typename?: 'DocumentSummary' } | { __typename?: 'DocumentSummaryPage' } | { __typename?: 'DocumentSummaryPrompt' } | { __typename?: 'DocumentSummaryPromptTestRun' } | { __typename?: 'DocumentSummaryTemplateBundleConfiguration' } | { __typename?: 'DonorAdvisedFund' } | { __typename?: 'Employee' } | { __typename?: 'EntitiesOverviewBundleConfiguration' } | { __typename?: 'EntitiesOverviewBundleConfigurationEntity' } | { __typename?: 'Entity', id: string, stage: Types.EntityStage, documents: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: { __typename?: 'Document', id: string, name: string, type: Types.DocumentType } | null } | null> | null }, entityDocumentRelationships: { __typename?: 'EntityDocumentRelationshipConnection', edges?: Array<{ __typename?: 'EntityDocumentRelationshipEdge', node?: { __typename?: 'EntityDocumentRelationship', id: string, relationshipType: Types.EntityDocumentRelationshipRelationshipType, document: { __typename?: 'Document', id: string, name: string, type: Types.DocumentType } } | null } | null> | null }, subtype: (
      { __typename?: 'CCorpBusinessEntity' }
      & BasicInformation_BusinessEntity_CCorpBusinessEntity_Fragment
    ) | (
      { __typename?: 'CLTTrust' }
      & BasicInformation_CltTrustFragment
    ) | (
      { __typename?: 'CRTTrust' }
      & BasicInformation_CrtTrustFragment
    ) | (
      { __typename?: 'CustodialPersonalAccount' }
      & BasicInformation_CustodialPersonalAccountFragment
    ) | (
      { __typename?: 'DonorAdvisedFund' }
      & BasicInformation_DafFragment
    ) | (
      { __typename?: 'GPBusinessEntity' }
      & BasicInformation_BusinessEntity_GpBusinessEntity_Fragment
    ) | (
      { __typename?: 'GRATTrust' }
      & BasicInformation_GratTrustFragment
    ) | (
      { __typename?: 'ILITTrust' }
      & BasicInformation_IlitTrustFragment
    ) | (
      { __typename?: 'IndividualPersonalAccount' }
      & BasicInformation_IndividualPersonalAccountFragment
    ) | (
      { __typename?: 'InsurancePersonalAccount' }
      & BasicInformation_InsurancePersonalAccountFragment
    ) | (
      { __typename?: 'IrrevocableTrust' }
      & BasicInformation_IrrevocableTrustFragment
    ) | (
      { __typename?: 'JointPersonalAccount' }
      & BasicInformation_JointPersonalAccountFragment
    ) | (
      { __typename?: 'LLCBusinessEntity' }
      & BasicInformation_BusinessEntity_LlcBusinessEntity_Fragment
    ) | (
      { __typename?: 'LPBusinessEntity' }
      & BasicInformation_BusinessEntity_LpBusinessEntity_Fragment
    ) | (
      { __typename?: 'PrivateFoundation' }
      & BasicInformation_PrivateFoundationFragment
    ) | (
      { __typename?: 'QPRTTrust' }
      & BasicInformation_QprtTrustFragment
    ) | (
      { __typename?: 'QualifiedTuitionPersonalAccount' }
      & BasicInformation_QualifiedTuitionPersonalAccountFragment
    ) | (
      { __typename?: 'RetirementPersonalAccount' }
      & BasicInformation_RetirementPersonalAccountFragment
    ) | (
      { __typename?: 'RevocableTrust' }
      & BasicInformation_RevocableTrustFragment
    ) | (
      { __typename?: 'SCorpBusinessEntity' }
      & BasicInformation_BusinessEntity_SCorpBusinessEntity_Fragment
    ) | (
      { __typename?: 'SLATTrust' }
      & BasicInformation_SlatTrustFragment
    ) | (
      { __typename?: 'SoleProprietorshipBusinessEntity' }
      & BasicInformation_BusinessEntity_SoleProprietorshipBusinessEntity_Fragment
    ) } | { __typename?: 'EntityDiagram' } | { __typename?: 'EntityDocumentRelationship' } | { __typename?: 'EntityGraphView' } | { __typename?: 'EntityGraphViewBundleConfiguration' } | { __typename?: 'EntityNotes' } | { __typename?: 'EntityProposal' } | { __typename?: 'EntitySummaryBundleConfiguration' } | { __typename?: 'EntitySummaryTemplateBundleConfiguration' } | { __typename?: 'EntityTask' } | { __typename?: 'EntityTaxInfo' } | { __typename?: 'EstateInsight' } | { __typename?: 'EstateInsightReference' } | { __typename?: 'EstateInsightsBundleConfiguration' } | { __typename?: 'EstateTaxScenario' } | { __typename?: 'EstateWaterfall' } | { __typename?: 'EstateWaterfallHypotheticalStateChange' } | { __typename?: 'EstateWaterfallHypotheticalTransfer' } | { __typename?: 'EstateWaterfallMessageContext' } | { __typename?: 'EstateWaterfallVisualizationConfig' } | { __typename?: 'EstateWaterfallVisualizationFilter' } | { __typename?: 'FamilyTreeBundleConfiguration' } | { __typename?: 'FamilyTreeConfiguration' } | { __typename?: 'FeatureFlag' } | { __typename?: 'FeatureFlagQueryRule' } | { __typename?: 'File' } | { __typename?: 'FilePage' } | { __typename?: 'FileParagraph' } | { __typename?: 'Form' } | { __typename?: 'FormVersion' } | { __typename?: 'GPBusinessEntity' } | { __typename?: 'GRATAnnuityV2' } | { __typename?: 'GRATProposalScenario' } | { __typename?: 'GRATTrust' } | { __typename?: 'GiftingProposal' } | { __typename?: 'GiftingProposalCashFlow' } | { __typename?: 'GiftingProposalGift' } | { __typename?: 'GiftingProposalGiftSender' } | { __typename?: 'GiftingProposalPortfolio' } | { __typename?: 'GiftingProposalScenario' } | { __typename?: 'GraphVisualizationGroup' } | { __typename?: 'GrowthProfile' } | { __typename?: 'GrowthProfileOverride' } | { __typename?: 'Household' } | { __typename?: 'HypotheticalCLT' } | { __typename?: 'HypotheticalCRT' } | { __typename?: 'HypotheticalGRAT' } | { __typename?: 'HypotheticalInsurance' } | { __typename?: 'HypotheticalSaleLoan' } | { __typename?: 'HypotheticalTransferAsset' } | { __typename?: 'HypotheticalTransferFundingSource' } | { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate' } | { __typename?: 'ILITCrummeyLetter' } | { __typename?: 'ILITTrust' } | { __typename?: 'Image' } | { __typename?: 'IncomeTaxPaymentConfig' } | { __typename?: 'IndividualPersonalAccount' } | { __typename?: 'InferredField' } | { __typename?: 'InferredFieldEvidence' } | { __typename?: 'InsightsTemplateBundleConfiguration' } | { __typename?: 'InsurancePersonalAccount' } | { __typename?: 'InsurancePolicy' } | { __typename?: 'InsurancePremiumPayment' } | { __typename?: 'IntegrationAssetClass' } | { __typename?: 'IntegrationCashflow' } | { __typename?: 'IntegrationClient' } | { __typename?: 'IntegrationConfiguration' } | { __typename?: 'IntegrationEntity' } | { __typename?: 'IntegrationInsurance' } | { __typename?: 'IntegrationLiability' } | { __typename?: 'IntegrationPerson' } | { __typename?: 'IrrevocableTrust' } | { __typename?: 'JointPersonalAccount' } | { __typename?: 'KGNode' } | { __typename?: 'KGRelationship' } | { __typename?: 'KGRoot' } | { __typename?: 'KGV2Document' } | { __typename?: 'KGV2DocumentChange' } | { __typename?: 'KGV2DocumentModification' } | { __typename?: 'KGV2Graph' } | { __typename?: 'KGV2Node' } | { __typename?: 'KGV2NodeAlias' } | { __typename?: 'KGV2NodeEvidence' } | { __typename?: 'KGV2Statement' } | { __typename?: 'KGV2StatementEvidence' } | { __typename?: 'KGV2StatementSupersession' } | { __typename?: 'KeyPerson' } | { __typename?: 'KeyPersonRole' } | { __typename?: 'LLCBusinessEntity' } | { __typename?: 'LPBusinessEntity' } | { __typename?: 'LiabilitiesBundleConfiguration' } | { __typename?: 'Liability' } | { __typename?: 'LiabilityPayment' } | { __typename?: 'LifeInsuranceBundleConfiguration' } | { __typename?: 'LifetimeExclusionEvent' } | { __typename?: 'LoggedTransfer' } | { __typename?: 'LuminaryOrganization' } | { __typename?: 'LuminaryTenantJIT' } | { __typename?: 'ManagedSFTPConnection' } | { __typename?: 'Memo' } | { __typename?: 'MemoPrompt' } | { __typename?: 'Message' } | { __typename?: 'MissingDocumentOverride' } | { __typename?: 'MissingDocumentsPage' } | { __typename?: 'ModelMapping' } | { __typename?: 'NotificationApp' } | { __typename?: 'NotificationPreference' } | { __typename?: 'OpenaiSdkConfig' } | { __typename?: 'OrganizationApplicationConfiguration' } | { __typename?: 'OrganizationDisclaimerConfiguration' } | { __typename?: 'OwnershipStake' } | { __typename?: 'PlatformDocument' } | { __typename?: 'PlatformFile' } | { __typename?: 'PlatformFilePage' } | { __typename?: 'PlatformFileParagraph' } | { __typename?: 'PresentationApprovalRequest' } | { __typename?: 'PresentationAssetDistributionBundleConfiguration' } | { __typename?: 'PresentationAssetDistributionItemConfiguration' } | { __typename?: 'PresentationAssetDistributionItemDetail' } | { __typename?: 'PresentationBundle' } | { __typename?: 'PresentationBundleCoverPage' } | { __typename?: 'PresentationBusinessOverviewBundleConfiguration' } | { __typename?: 'PresentationBusinessOverviewBusinessConfiguration' } | { __typename?: 'PresentationBusinessOverviewItem' } | { __typename?: 'PresentationCoverPage' } | { __typename?: 'PresentationCoverSlideConfig' } | { __typename?: 'PresentationCustomPage' } | { __typename?: 'PresentationCustomPageBundleConfiguration' } | { __typename?: 'PresentationDiagramPage' } | { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' } | { __typename?: 'PresentationDocumentsReviewedDocument' } | { __typename?: 'PresentationFamilyOverviewBundleConfiguration' } | { __typename?: 'PresentationFamilyOverviewMemberConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveClientConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveItem' } | { __typename?: 'PresentationItemCitation' } | { __typename?: 'PresentationPage' } | { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' } | { __typename?: 'PresentationPlanningOpportunitiesItem' } | { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' } | { __typename?: 'PresentationPowerOfAttorneyClientConfiguration' } | { __typename?: 'PresentationPowerOfAttorneyItem' } | { __typename?: 'PresentationTemplate' } | { __typename?: 'PresentationTemplateBundle' } | { __typename?: 'PresentationTemplateCoverPage' } | { __typename?: 'PresentationTemplateCustomPage' } | { __typename?: 'PresentationTemplateDiagramPage' } | { __typename?: 'PresentationTemplatePage' } | { __typename?: 'PresentationTrustOverviewBundleConfiguration' } | { __typename?: 'PresentationTrustOverviewItem' } | { __typename?: 'PresentationTrustOverviewTrustConfiguration' } | { __typename?: 'PresentationWillBundleConfiguration' } | { __typename?: 'PresentationWillClientConfiguration' } | { __typename?: 'PresentationWillItem' } | { __typename?: 'Principal' } | { __typename?: 'PrivateFoundation' } | { __typename?: 'ProfessionalTeamRole' } | { __typename?: 'Proposal' } | { __typename?: 'ProposalScenario' } | { __typename?: 'QPRTTrust' } | { __typename?: 'QualifiedTuitionPersonalAccount' } | { __typename?: 'ReleaseGroup' } | { __typename?: 'ReminderEmailNotificationRecord' } | { __typename?: 'RetirementPersonalAccount' } | { __typename?: 'RevocableTrust' } | { __typename?: 'Role' } | { __typename?: 'SCorpBusinessEntity' } | { __typename?: 'SLATTrust' } | { __typename?: 'SSOConnection' } | { __typename?: 'SalesforceExportAttempt' } | { __typename?: 'ScheduledDistribution' } | { __typename?: 'SoleProprietorshipBusinessEntity' } | { __typename?: 'SubBrand' } | { __typename?: 'SubBrandDisclaimerConfiguration' } | { __typename?: 'Submission' } | { __typename?: 'TaxDragConfig' } | { __typename?: 'TaxDragOverride' } | { __typename?: 'Team' } | { __typename?: 'Tenant' } | { __typename?: 'TenantApplicationConfiguration' } | { __typename?: 'TenantBranding' } | { __typename?: 'TenantDisclaimerConfiguration' } | { __typename?: 'TenantDocument' } | { __typename?: 'TenantReminderEmailsConfiguration' } | { __typename?: 'TenantSSOConnection' } | { __typename?: 'TenantSecurityConfiguration' } | { __typename?: 'TenantSlideConfig' } | { __typename?: 'TestCMKEncryption' } | { __typename?: 'TestamentaryEntity' } | { __typename?: 'TrustAdvisor' } | { __typename?: 'TrustAdvisorRole' } | { __typename?: 'Trustee' } | { __typename?: 'TrusteeDuty' } | { __typename?: 'User' } | { __typename?: 'UserFeedback' } | { __typename?: 'UserNotificationConfiguration' } | { __typename?: 'WaterfallBundleConfiguration' } | { __typename?: 'WaterfallBundleCoverPage' } | { __typename?: 'WaterfallComparisonBundleConfiguration' } | { __typename?: 'WaterfallComparisonTemplateBundleConfiguration' } | { __typename?: 'WaterfallTemplateBundleConfiguration' } | { __typename?: 'WorkOSOrganization' } | { __typename?: 'WorkOSOrganizationDomain' } | { __typename?: 'WorkflowTracker' } | null };

export const Operations = {
  Query: {
    GetBasicInformation: 'GetBasicInformation' as const
  },
  Fragment: {
    BasicInformation_Grantor: 'BasicInformation_Grantor' as const,
    BasicInformation_ControllingParty: 'BasicInformation_ControllingParty' as const,
    BasicInformation_Owner: 'BasicInformation_Owner' as const,
    BasicInformation_IrrevocableTrust: 'BasicInformation_IrrevocableTrust' as const,
    BasicInformation_RevocableTrust: 'BasicInformation_RevocableTrust' as const,
    BasicInformation_SLATTrust: 'BasicInformation_SLATTrust' as const,
    BasicInformation_ILITTrust: 'BasicInformation_ILITTrust' as const,
    BasicInformation_GRATTrust: 'BasicInformation_GRATTrust' as const,
    BasicInformation_QPRTTrust: 'BasicInformation_QPRTTrust' as const,
    BasicInformation_IndividualPersonalAccount: 'BasicInformation_IndividualPersonalAccount' as const,
    BasicInformation_JointPersonalAccount: 'BasicInformation_JointPersonalAccount' as const,
    BasicInformation_InsurancePersonalAccount: 'BasicInformation_InsurancePersonalAccount' as const,
    BasicInformation_CLTTrust: 'BasicInformation_CLTTrust' as const,
    BasicInformation_CRTTrust: 'BasicInformation_CRTTrust' as const,
    BasicInformation_RetirementPersonalAccount: 'BasicInformation_RetirementPersonalAccount' as const,
    BasicInformation_CustodialPersonalAccount: 'BasicInformation_CustodialPersonalAccount' as const,
    BasicInformation_QualifiedTuitionPersonalAccount: 'BasicInformation_QualifiedTuitionPersonalAccount' as const,
    BasicInformation_DAF: 'BasicInformation_DAF' as const,
    BasicInformation_PrivateFoundation: 'BasicInformation_PrivateFoundation' as const,
    BasicInformation_BusinessEntity: 'BasicInformation_BusinessEntity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const BasicInformation_GrantorFragmentDoc = gql`
    fragment BasicInformation_Grantor on Principal {
  id
  ownershipPercentage
  individual {
    id
    legalName
  }
}
    `;
export const BasicInformation_IrrevocableTrustFragmentDoc = gql`
    fragment BasicInformation_IrrevocableTrust on IrrevocableTrust {
  id
  description
  entityExists
  displayName
  effectiveDate
  legalName
  successorTrustees {
    id
  }
  tenantID
  trustAdvisors {
    id
  }
  trustJurisdictionStateCode
  trustees {
    id
  }
  grantors {
    ...BasicInformation_Grantor
  }
}
    ${BasicInformation_GrantorFragmentDoc}`;
export const BasicInformation_RevocableTrustFragmentDoc = gql`
    fragment BasicInformation_RevocableTrust on RevocableTrust {
  id
  description
  entityExists
  displayName
  effectiveDate
  legalName
  successorTrustees {
    id
  }
  tenantID
  trustAdvisors {
    id
  }
  trustJurisdictionStateCode
  trustees {
    id
  }
  grantors {
    ...BasicInformation_Grantor
  }
}
    ${BasicInformation_GrantorFragmentDoc}`;
export const BasicInformation_SlatTrustFragmentDoc = gql`
    fragment BasicInformation_SLATTrust on SLATTrust {
  id
  description
  entityExists
  displayName
  effectiveDate
  legalName
  successorTrustees {
    id
  }
  tenantID
  trustAdvisors {
    id
  }
  trustJurisdictionStateCode
  trustees {
    id
  }
  slatGrantor: grantor {
    ...BasicInformation_Grantor
  }
}
    ${BasicInformation_GrantorFragmentDoc}`;
export const BasicInformation_IlitTrustFragmentDoc = gql`
    fragment BasicInformation_ILITTrust on ILITTrust {
  id
  description
  entityExists
  displayName
  effectiveDate
  legalName
  successorTrustees {
    id
  }
  tenantID
  trustAdvisors {
    id
  }
  trustJurisdictionStateCode
  trustees {
    id
  }
  grantors {
    ...BasicInformation_Grantor
  }
}
    ${BasicInformation_GrantorFragmentDoc}`;
export const BasicInformation_GratTrustFragmentDoc = gql`
    fragment BasicInformation_GRATTrust on GRATTrust {
  id
  description
  entityExists
  displayName
  taxableGift
  officialInterestRatePercent
  effectiveDate
  legalName
  initialFundingValue
  successorTrustees {
    id
  }
  tenantID
  termDurationYears
  trustAdvisors {
    id
  }
  trustJurisdictionStateCode
  trustees {
    id
  }
  gratGrantor: grantor {
    ...BasicInformation_Grantor
  }
}
    ${BasicInformation_GrantorFragmentDoc}`;
export const BasicInformation_QprtTrustFragmentDoc = gql`
    fragment BasicInformation_QPRTTrust on QPRTTrust {
  id
  termDurationYears
  officialInterestRatePercent
  taxableGift
  description
  entityExists
  displayName
  effectiveDate
  legalName
  successorTrustees {
    id
  }
  tenantID
  trustAdvisors {
    id
  }
  trustJurisdictionStateCode
  trustees {
    id
  }
  grantors {
    ...BasicInformation_Grantor
  }
}
    ${BasicInformation_GrantorFragmentDoc}`;
export const BasicInformation_OwnerFragmentDoc = gql`
    fragment BasicInformation_Owner on Principal {
  id
  ownershipPercentage
  individual {
    id
    displayName
  }
}
    `;
export const BasicInformation_ControllingPartyFragmentDoc = gql`
    fragment BasicInformation_ControllingParty on ControllingParty {
  id
  individual {
    id
    displayName
  }
  organization {
    id
    name
  }
}
    `;
export const BasicInformation_IndividualPersonalAccountFragmentDoc = gql`
    fragment BasicInformation_IndividualPersonalAccount on IndividualPersonalAccount {
  id
  description
  entityExists
  displayName
  effectiveDate
  legalName
  tenantID
  owner {
    ...BasicInformation_Owner
  }
  controllingParties {
    ...BasicInformation_ControllingParty
  }
}
    ${BasicInformation_OwnerFragmentDoc}
${BasicInformation_ControllingPartyFragmentDoc}`;
export const BasicInformation_JointPersonalAccountFragmentDoc = gql`
    fragment BasicInformation_JointPersonalAccount on JointPersonalAccount {
  id
  jointAccountType: type
  description
  entityExists
  displayName
  effectiveDate
  legalName
  tenantID
  owners {
    ...BasicInformation_Owner
  }
  controllingParties {
    ...BasicInformation_ControllingParty
  }
}
    ${BasicInformation_OwnerFragmentDoc}
${BasicInformation_ControllingPartyFragmentDoc}`;
export const BasicInformation_InsurancePersonalAccountFragmentDoc = gql`
    fragment BasicInformation_InsurancePersonalAccount on InsurancePersonalAccount {
  id
  description
  entityExists
  displayName
  effectiveDate
  legalName
  tenantID
  owners {
    ...BasicInformation_Owner
  }
  controllingParties {
    ...BasicInformation_ControllingParty
  }
}
    ${BasicInformation_OwnerFragmentDoc}
${BasicInformation_ControllingPartyFragmentDoc}`;
export const BasicInformation_CltTrustFragmentDoc = gql`
    fragment BasicInformation_CLTTrust on CLTTrust {
  id
  termDurationYears
  officialInterestRatePercent
  description
  entityExists
  displayName
  effectiveDate
  legalName
  charitableDeduction
  termDurationLifetime
  successorTrustees {
    id
  }
  tenantID
  trustAdvisors {
    id
  }
  trustJurisdictionStateCode
  trustees {
    id
  }
  grantors {
    ...BasicInformation_Grantor
  }
}
    ${BasicInformation_GrantorFragmentDoc}`;
export const BasicInformation_CrtTrustFragmentDoc = gql`
    fragment BasicInformation_CRTTrust on CRTTrust {
  id
  termDurationYears
  officialInterestRatePercent
  description
  entityExists
  displayName
  effectiveDate
  legalName
  charitableDeduction
  termDurationLifetime
  successorTrustees {
    id
  }
  tenantID
  trustAdvisors {
    id
  }
  trustJurisdictionStateCode
  trustees {
    id
  }
  grantors {
    ...BasicInformation_Grantor
  }
}
    ${BasicInformation_GrantorFragmentDoc}`;
export const BasicInformation_RetirementPersonalAccountFragmentDoc = gql`
    fragment BasicInformation_RetirementPersonalAccount on RetirementPersonalAccount {
  id
  description
  entityExists
  displayName
  effectiveDate
  legalName
  tenantID
  retirementAccountType: type
  custodian
  owner {
    ...BasicInformation_Owner
  }
  controllingParties {
    ...BasicInformation_ControllingParty
  }
}
    ${BasicInformation_OwnerFragmentDoc}
${BasicInformation_ControllingPartyFragmentDoc}`;
export const BasicInformation_CustodialPersonalAccountFragmentDoc = gql`
    fragment BasicInformation_CustodialPersonalAccount on CustodialPersonalAccount {
  id
  description
  entityExists
  displayName
  effectiveDate
  legalName
  tenantID
  owner {
    ...BasicInformation_Owner
  }
  controllingParties {
    ...BasicInformation_ControllingParty
  }
}
    ${BasicInformation_OwnerFragmentDoc}
${BasicInformation_ControllingPartyFragmentDoc}`;
export const BasicInformation_QualifiedTuitionPersonalAccountFragmentDoc = gql`
    fragment BasicInformation_QualifiedTuitionPersonalAccount on QualifiedTuitionPersonalAccount {
  id
  description
  entityExists
  displayName
  effectiveDate
  legalName
  tenantID
  owner {
    ...BasicInformation_Owner
  }
  controllingParties {
    ...BasicInformation_ControllingParty
  }
}
    ${BasicInformation_OwnerFragmentDoc}
${BasicInformation_ControllingPartyFragmentDoc}`;
export const BasicInformation_DafFragmentDoc = gql`
    fragment BasicInformation_DAF on DonorAdvisedFund {
  id
  description
  entityExists
  displayName
  effectiveDate
  legalName
  tenantID
  donors {
    ...BasicInformation_Owner
  }
  controllingParties {
    ...BasicInformation_ControllingParty
  }
}
    ${BasicInformation_OwnerFragmentDoc}
${BasicInformation_ControllingPartyFragmentDoc}`;
export const BasicInformation_PrivateFoundationFragmentDoc = gql`
    fragment BasicInformation_PrivateFoundation on PrivateFoundation {
  id
  description
  entityExists
  displayName
  effectiveDate
  legalName
  tenantID
  donors {
    ...BasicInformation_Owner
  }
  controllingParties {
    ...BasicInformation_ControllingParty
  }
}
    ${BasicInformation_OwnerFragmentDoc}
${BasicInformation_ControllingPartyFragmentDoc}`;
export const BasicInformation_BusinessEntityFragmentDoc = gql`
    fragment BasicInformation_BusinessEntity on BusinessEntity {
  id
  description
  entityExists
  displayName
  effectiveDate
  legalName
  doingBusinessAsName
  formationJurisdictionStateCode
  requiresCtaReporting
  finCenID
}
    `;
export const GetBasicInformationDocument = gql`
    query GetBasicInformation($nodeId: ID!) {
  node(id: $nodeId) {
    ... on Entity {
      id
      stage
      documents {
        edges {
          node {
            id
            name
            type
          }
        }
      }
      entityDocumentRelationships {
        edges {
          node {
            id
            relationshipType
            document {
              id
              name
              type
            }
          }
        }
      }
      subtype {
        ...BasicInformation_IrrevocableTrust
        ...BasicInformation_RevocableTrust
        ...BasicInformation_SLATTrust
        ...BasicInformation_ILITTrust
        ...BasicInformation_GRATTrust
        ...BasicInformation_QPRTTrust
        ...BasicInformation_CLTTrust
        ...BasicInformation_CRTTrust
        ...BasicInformation_IndividualPersonalAccount
        ...BasicInformation_JointPersonalAccount
        ...BasicInformation_InsurancePersonalAccount
        ...BasicInformation_RetirementPersonalAccount
        ...BasicInformation_CustodialPersonalAccount
        ...BasicInformation_QualifiedTuitionPersonalAccount
        ...BasicInformation_DAF
        ...BasicInformation_PrivateFoundation
        ...BasicInformation_BusinessEntity
      }
    }
  }
}
    ${BasicInformation_IrrevocableTrustFragmentDoc}
${BasicInformation_RevocableTrustFragmentDoc}
${BasicInformation_SlatTrustFragmentDoc}
${BasicInformation_IlitTrustFragmentDoc}
${BasicInformation_GratTrustFragmentDoc}
${BasicInformation_QprtTrustFragmentDoc}
${BasicInformation_CltTrustFragmentDoc}
${BasicInformation_CrtTrustFragmentDoc}
${BasicInformation_IndividualPersonalAccountFragmentDoc}
${BasicInformation_JointPersonalAccountFragmentDoc}
${BasicInformation_InsurancePersonalAccountFragmentDoc}
${BasicInformation_RetirementPersonalAccountFragmentDoc}
${BasicInformation_CustodialPersonalAccountFragmentDoc}
${BasicInformation_QualifiedTuitionPersonalAccountFragmentDoc}
${BasicInformation_DafFragmentDoc}
${BasicInformation_PrivateFoundationFragmentDoc}
${BasicInformation_BusinessEntityFragmentDoc}`;

/**
 * __useGetBasicInformationQuery__
 *
 * To run a query within a React component, call `useGetBasicInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasicInformationQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useGetBasicInformationQuery(baseOptions: Apollo.QueryHookOptions<GetBasicInformationQuery, GetBasicInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBasicInformationQuery, GetBasicInformationQueryVariables>(GetBasicInformationDocument, withFetchPolicyContext(options));
      }
export function useGetBasicInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasicInformationQuery, GetBasicInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBasicInformationQuery, GetBasicInformationQueryVariables>(GetBasicInformationDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetBasicInformationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBasicInformationQuery, GetBasicInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBasicInformationQuery, GetBasicInformationQueryVariables>(GetBasicInformationDocument, withFetchPolicyContext(options));
        }
export type GetBasicInformationQueryHookResult = ReturnType<typeof useGetBasicInformationQuery>;
export type GetBasicInformationLazyQueryHookResult = ReturnType<typeof useGetBasicInformationLazyQuery>;
export type GetBasicInformationSuspenseQueryHookResult = ReturnType<typeof useGetBasicInformationSuspenseQuery>;
export type GetBasicInformationQueryResult = Apollo.QueryResult<GetBasicInformationQuery, GetBasicInformationQueryVariables>;